const smartWalletLocalEn = {
    connecting: "Connecting to Smart Account",
    failedToConnect: "Failed to connect to Smart Account",
    wrongNetworkScreen: {
        title: "Wrong Network",
        subtitle: "Your wallet is not connected to the required network",
        failedToSwitch: "Failed to switch network",
    },
};
export default smartWalletLocalEn;
//# sourceMappingURL=en.js.map